import {Component, OnInit} from '@angular/core';
import {MapperService} from '../../services/mapper.service';
import {MatDialog} from '@angular/material/dialog';
import {CreatePlanDialogComponent} from './create-plan.dialog.component';
import {A0} from '../../shared/entities/A0.entity';
import {AuthService} from '../../services/auth.service';
import {Router} from '@angular/router';
import {FormControl, FormGroup} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styles: [`
  `],
  standalone: false
})
export class DashboardComponent implements OnInit {

  public listRisques: any[] = [];

  public _listPlans: A0[] = [];
  public listPlans: A0[] = [];

  public userName = '';

  public filters = new FormGroup({
    searchTerm: new FormControl(''),
    typePlan: new FormControl<'territoire' | 'user' | 'all'>('all'),
    typeRisque: new FormControl(''),
    date: new FormGroup({
      start: new FormControl<Date | null>(null),
      end: new FormControl<Date | null>(null),
    })
  });

  constructor(
    public mapperService: MapperService,
    public authService: AuthService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    public router: Router,
  ) {
    this.mapperService.getListOfRiskTypes().subscribe((list) => {
      this.listRisques = list;
    });
  }

  ngOnInit(): void {
    this.updateListing();

    this.userName = this.getUserName();

    this.filters.valueChanges.subscribe(() => {
      this.applyFilters();
    });
  }

  getUserName(): string {
    return JSON.parse(sessionStorage.getItem('user'))?.user_name ?? '';
  }

  createPlan(): any {
    this.dialog.open(CreatePlanDialogComponent, {
      width: '600px',
      maxWidth: '100%'
    }).afterClosed().subscribe((plan: A0) => {
      if (plan) {
        this.mapperService.createPlan(plan).subscribe(
          () => this.updateListing(),
          (err) => {
            this.snackBar.open(`Erreur lors de la création du plan`, 'Fermer', { duration: 5000 } );
          });
      }
    });
  }

  updateListing(): void {
    this.mapperService.getListPlan().subscribe((list: A0[]) => {
      this._listPlans = list;
      this.applyFilters();
    });
  }

  isTypePlanSelected(plan: A0, typePlan: 'territoire' | 'user' | 'all'): boolean {
    if (typePlan === 'all') {
      return true;
    }
    return typePlan === 'user' ? !!plan.id_user : !plan.id_user;
  }


  applyFilters(): void {
    const {date, searchTerm, typePlan, typeRisque} = this.filters.value;

    this.listPlans = this._listPlans.filter((plan: A0) => {
      const terms = `${plan.title} ${plan.code_zone} ${plan.type_zone} ${plan.type_risque} ${plan.name_zone}`.toLowerCase();

      const matchesTerm = searchTerm ? terms.includes(searchTerm.toLowerCase()) : true;
      const matchesTypePlan = typePlan ? this.isTypePlanSelected(plan, typePlan) : true;
      const matchesTypeRisque = typeRisque ? plan.type_risque === typeRisque : true;

      let matchesDateRange = true;
      const planDate = new Date(plan.created_at);
      if (date.start) {
        matchesDateRange = matchesDateRange && (planDate >= date.start);
      }
      if (date.end) {
        matchesDateRange = matchesDateRange && (planDate <= date.end);
      }

      return matchesTerm && matchesTypePlan && matchesTypeRisque && matchesDateRange;
    });
  }

  clearSearch(): void {
    this.filters.patchValue({searchTerm: '', typeRisque: '', date: {start: null, end: null}, typePlan: 'all'} );
  }

  logout(): void {
    this.authService.logout().subscribe(() => {
      this.router.navigate(['/unauthorized']);
    }, () => {
      this.router.navigate(['/unauthorized']);
    });
  }
}
